import { Box, Button, IconButton, InputAdornment, TextField } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { GameCssStyles } from "../GameManagement/GameCssStyles";

const SearchBar = ({ searchText, setSearchText, handleSearch, handleClearSearch }) => {
  return (
    <Box sx={{

      flex: 0.6,
      justifyContent: "space-between",
      alignItems: "center",
      mb: 0,
      px: 2,
      flexDirection:'row'
    }}>

      <TextField
        fullWidth
        label="Search by name"
        variant="outlined"
        value={searchText}
        onChange={(e) =>
          setSearchText(e.target.value)
        }
        sx={GameCssStyles.formSingleLineTextField_sx}
        InputProps={{
          endAdornment: searchText && (
            <InputAdornment position="end">
              <IconButton onClick={handleClearSearch} size="small">
                <ClearIcon />
              </IconButton>

              <IconButton onClick={handleSearch} size="small">
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

    </Box>
  );
}


export default SearchBar;